export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref13947.969adc4a.jpg";